<template>
  <b-container fluid>
    <h1>
      Add an inventory request order (Took Part
      <sup style="top:-2em;font-size:30%;">that are also products</sup>)
    </h1>

    <b-alert
      v-model="top_alert.show"
      :variant="top_alert.variant"
      dismissible>
        {{ this.top_alert.text }}
    </b-alert>

    <b-row class="my-2" v-if="googleUser.emails">
      <b-col>
        <b-card header="Parts">
          <order-items
          :parts="parts"
          :items-adding="itemsToAdd"
          :index="itemsKey"
          @refreshTable="refreshTable"/>
        </b-card>
      </b-col>
    </b-row>

    <b-row align-h="between" class="my-2" v-if="googleUser.emails">
      <b-col cols="4">
        <b-button-group
        >
          <b-button
          variant="success"
          @click="showNotesModal"
          >Submit Order
          </b-button>
          <b-button
            variant="info"
            @click="updateFileModal(true)"
          >Upload CSV file
          </b-button>
        </b-button-group>
      </b-col>
      <b-col>
        <a href="https://docs.google.com/document/d/1-144NEKXAWkC8pH7L2rF0_Qte9p1Nu7r/edit" target="_blank" class="btn btn-info">Inventory Request Process Documentation</a>
      </b-col>
      <b-col cols="2">
        <b-button
          variant="danger"
        @click="clearOrder"
        >Clear Order
        </b-button>
      </b-col>
    </b-row>

    <product-search
      :parts="parts"
      @add="addToOrder"/>


    <b-modal v-model="notes.show" title="Details" no-close-on-backdrop hide-footer>
      <center>
        <b-alert class="mb-2" v-model="notes.invalidNote" dismissible variant="danger">{{ notes.warning }}</b-alert>
        <b-form-row class="mb-2">
          <span>Please select the department this request is for:</span>
          <b-form-select v-model="notes.user_department" :options="list_options"> </b-form-select>
        </b-form-row>
        <b-form-row class="my-2">
          <span>Please include a note for the purpose of the order</span>
          <b-form-textarea class="my-2" v-model="notes.text" rows="4" max-rows="6" placeholder="Add notes"/>
        </b-form-row>
        <b-form-row class="mb-2">
          <span>Indicate urgency/time for fulfillment</span>
          <b-form-input class="w-40 my-2" v-model="notes.urgency"/>
        </b-form-row>
        <b-form-row class="mb-2">
          <span>If the order is part of a project indicate here  ----  {{ this.notes.project.length }}/130</span>
          <b-form-input class="w-40 my-2" :state="projectValid" v-model="notes.project"/>
        </b-form-row>
        <b-row class="mt-2" align-h="end">
          <b-col cols="3">
            <b-button variant="primary" @click="submitNotes">Submit</b-button>
          </b-col>
          <b-col cols="9">
            <b-form-checkbox v-b-popover.hover="'Check this even if only some of the items will be returned'" v-model="notes.returnFlag">Items from this order will be returned</b-form-checkbox>
          </b-col>
        </b-row>
      </center>
    </b-modal>

    <list-upload
      :show="listUpload.visible"
      @addItems="addSimpleItems"
      @visibilityChange="updateFileModal"/>

    <review-modal
      :visible="review.visible"
      :soitems="productParts"
      :specialitems="nonProductParts"
      :department="notes.user_department"
      :notes="notes"
      :ordernum="orderNum"
      @close="() => {review.visible = false}"
      @confirm="() => {review.visible = false; this.newSubmit()}"/>

    <b-modal
      hide-header
      hide-footer
      ref="spinner-modal">
      <center>
        <p>Waiting to get order ID...</p>
        <fingerprint-spinner
          :animation-duration="1500"
          :size="300" color="#990000"
          class="my-3" />
      </center>
    </b-modal>

    <b-modal v-model="modal.show" ok-only hide-header :body-bg-variant="modal.variant">
      <b-row class="m-2">
        <p class="mt-2">{{ modal.text }}</p><br>
        <p v-if="modal.error_text" class="mt-2"><strong>Error: </strong>{{ modal.error_text }}</p><br>


      </b-row>
      <template slot="modal-footer">
        <b-button
          v-if="modal.button_text"
          variant="primary"
          @click="() => {
            modal.show = false;
            if (modal.redirect) $router.push(modal.redirect);
          }"
        >
        {{ modal.button_text }}
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>


<script>
import axios from 'axios';
import jsontoxml from 'jsonxml'
import { mapActions, mapGetters } from 'vuex';
import { FingerprintSpinner } from 'epic-spinners'

import ProductSearch from './ProductSearch.vue'
import OrderItems from './OrderItems.vue'
import ReviewModal from './ReviewModal.vue'
import ListUpload from './ListUpload.vue'
import Fishion from '../../../services/fishion';
import Fishbowl from '../../../services/fishbowl.js'
import Utility from '../../../helpers/utility.js'
import ChampService from '../../../services/champ';
import RequestService from '../../../services/requestorder.js';

let ORDER_PREFIX = 'TP';
let PREFIX_SEPARATOR = ORDER_PREFIX.substr(-1);

export default {
  name: 'inventory-request',
  components: {
    ProductSearch,
    FingerprintSpinner,
    OrderItems,
    ReviewModal,
    ListUpload,
  },
  data() {
    return {
      uuid: '',
      parts: [],
      listUpload: {
        visible: false,
      },
      itemsKey: false,
      itemsBusy: false,
      itemsToAdd: 0,
      itemsAdded: 0,
      orderNum: '',
      emails: [],
      productParts: [],
      nonProductParts: [],
      qtyCheck: {
        items: [],
        invalid: false,
        alert: '',
      },
      modal: {
        text: '',
        error_text: '',
        button_text: '',
        variant: '',
        redirect: '',
        spinner: false,
        show: false,
      },
      notes: {
        text: '',
        urgency: 'ASAP (default)',
        project: '',
        returnFlag: false,
        warning: 'Please enter the purpose of your inventory request',
        invalidNote: false,
        show: false,
        user_department: 'AndyMark Development',
      },
      review: {
        visible: false,
      },
      list_options: [
        {text: 'Development', value: 'AndyMark Development'},
        {text: 'Operations',  value: 'AndyMark Operations'},
        {text: 'Marketing',   value: 'AndyMark Marketing'},
        {text: 'Machine Shop', value: 'AndyMark Machine Shop'},
        {text: 'IT',          value: 'AndyMark IT'},
        {text: 'CyberTooth',  value: 'CyberTooth Robotics Team'},
        {text: 'Event',  value: 'AndyMark Event Parts'},
      ],
      top_alert: {
        text: 'You are not logged in!!',
        variant: '',
        show: this.userLoggedIn,
      },
    }
  },
  mounted() {
    if (this.googleUser == null || this.googleUser.internalOnly) {
      this.showTopAlert('Please log in before creating your request', 'danger');
    }
  },
  computed: {
    ...mapGetters({
      googleUser: 'loggedInUser',
    }),
    userLoggedIn() {
      return this.googleUser != null;
    },
    itemsInOrder() {
      return this.parts.length != 0;
    },
    projectValid() {
      if (this.notes.project.length > 130) {
        return false;
      }
      else {
        return null;
      }
    }
  },
  methods: {
    refreshTable() {
      this.itemsKey != this.itemsKey;
    },
    clearOrder() {
      this.parts = [];
      this.orderNum = '';
      this.emails = [];
      this.nonProductParts = [];
      this.notes.text = '';
      this.notes.project = '';
      this.notes.urgency = 'ASAP (default)';
      this.notes.returnFlag = false;
    },
    findInOrder( part ){
      return this.findNumInOrder(part.product_num == 0 ? part.part_num : part.product_num);
    },
    findNumInOrder( num ){
      return this.parts.map((e) => { return e.num } ).indexOf(num);
    },
    getRowStyle( part ) {
      if (part.item_type == 'Kit') {
        return 'secondary';
      }
      else if (part.product_id == 0) {
        return 'warning';
      }
      return '';
    },
    addToOrder ( part, qty = 1 ) {
      if (!this.userLoggedIn) {
       this.showTopAlert('Please log in before creating your request', 'danger');
      } else {
        var newItemRef = this.itemsAdded++;
        this.parts.push({
          reference:      newItemRef,
          qty:            qty,
          nonProductFlag: part.product_num == '0',
          parentItem:     '',
          prodid:         part.product_id,
          num:            part.product_num == '0' ? part.part_num : part.product_num,
          description:    part.product_id == 0 ? part.part_desc : part.product_desc,
          note:           part.note,
          available:      part.fb_available_for_sale,
          canBuild:       part.can_build_make,
          uom:            part.uom,
          type:           part.item_type,
          itemType:       part.item_type == 'Kit' ? 80 : 10,
          level:          0,
          qtyPerParent:   0,
          _rowVariant:    this.getRowStyle(part),
        });

        if (part.item_type == 'Kit') {
          this.addKit(part, qty, newItemRef);
        }
      }
    },
    addKit( kit, qty, kitRef, level = 0 ) {
      if (level == 0) this.itemsBusy = true;
      Fishbowl.getKitContents(kit.product_id).then((response) =>{
        for (let ix in response) {
          let item = response[ix];
          if (item.kittypeid == 10) {
            continue;
          }
          let newItemRef = this.itemsAdded;
          this.addItemByProductNum(item.kititemnum, item.quantity * qty, `${kit.product_num},${item.quantity}`, kitRef,  level);

          if (item.kititemtypeid == 20) {
            this.addKit({product_id: item.kititemid, product_num: item.kititemnum}, item.quantity * qty, newItemRef, level + 1);
          }

        }
      });
    },
    addItemByProductNum( productNum, qty, parentStr = '', parentRef = -1, parentLevel = -1 ) {
        var placeInOrder = this.findNumInOrder(productNum);
        let newItemRef   = this.itemsAdded++;

        let parentIndex = -1;
        if (parentRef != -1) {
          parentIndex  = this.indexByRef(parentRef);
          this.parts.splice(parentIndex + 1, 0, {reference: newItemRef})
        }
        else {
          this.parts.push({reference: newItemRef});
        }
        this.itemsToAdd++;
          Fishion.searchInventoryCalculations({productNum: productNum.replace(/[\n\r]+/g, ''), exactMatch: 'true'}).then((response) => {
            if (response.length == 0) {
              this.parts.splice(this.indexByRef(newItemRef), 1);
            }
            else {
              var item = response[0];
              //console.log(`READY TO TRY ON PARENT REF: ${parentRef}`)
              //console.log(`Parent index: ${parentIndex}`);
              // let itemIndex = this.parts.slice(startIndex, -1).map((x) => {return x.num}).indexOf(productNum);
              this.parts[this.indexByRef(newItemRef)] = {
                qty:           qty,
                reference:     newItemRef,
                nonProductFlag: false,
                parentItem:    parentStr,
                prodid:        item.product_id,
                num:           item.product_num,
                description:   item.product_desc,
                available:     item.fb_available_for_sale,
                canBuild:      item.can_build_make,
                itemType:      item.item_type == 'Kit' ? 80 : 10,
                uom:           item.uom,
                type:          item.item_type,
                level:         parentLevel + 1,
                qtyPerParent:  qty,
                _rowVariant: item.item_type == 'Kit' ? 'secondary' : ''
              }
            }
            this.itemsKey = !this.itemsKey;
            this.itemsToAdd--;
          });
    },
    addSimpleItems( itemsToAdd ) {
      for (let i in itemsToAdd) {
        let existingIndex = this.findNumInOrder(itemsToAdd[i].num);
        if (existingIndex == -1) {
          this.addItemByProductNum(itemsToAdd[i].num, parseInt(itemsToAdd[i].qty));
        }
        else {
          this.parts[existingIndex].qty = parseInt(this.parts[existingIndex].qty) + parseInt(itemsToAdd[i].qty);
        }
      }
    },
    indexByRef( ref ) {
      return this.parts.map((x) => {return x.reference}).indexOf(ref);
    },
    esc( str ){
      return (''+str).replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&apos;')
        .replace(/"/g, '&quot;')
        .replace(/[^\x09\x0A\x0D\x20-\xFF\x85\xA0-\uD7FF\uE000-\uFDCF\uFDE0-\uFFFD]/gm, '');
    },
    submitNotes() {
      if (this.notes.text != '' || (this.notes.project != ''  && this.notes.project.length <= 130)) {
        this.notes.show = false;
        this.notes.invalidNote = false;

        if (this.precheckItems()) {
          this.review.visible = true;
        }
        return;
      } else {
        this.notes.invalidNote = true;
      }
    },
    precheckItems() {
      this.top_alert.show  = false;
      this.nonProductParts = [];
      this.productParts    = [];
      this.qtyCheck.items  = [];
      this.qtyCheck.alert  = '';
      this.qtyCheck.invalid = false;
      this.parts.filter((x) => {
        if (!x.nonProductFlag) {
          this.productParts.push({
            num: x.num,
            qty: x.qty,
            limit: x.available + x.canBuild,
            level: x.level,
            itemType: x.itemType,
            desc: x.description,
          })
          return x;
        } else {
          this.nonProductParts.push({
            num: x.num,
            qty: x.qty,
            desc: x.description,
          });
        }
      });

      for (let ix in this.productParts) {
        let currPart = this.productParts[ix];
        let currIndex = this.qtyCheck.items.map((x) => {return x.num}).indexOf(currPart.num);
        if (currIndex == -1) {
          this.qtyCheck.items.push({num: currPart.num, limit: currPart.limit, qty: parseInt(currPart.qty)})
        }
        else {
          this.qtyCheck.items[currIndex].qty += parseInt(this.productParts[ix].qty);
          if (this.qtyCheck.items[currIndex].qty > this.qtyCheck.items[currIndex].limit) {
            this.qtyCheck.invalid = true;
            this.qtyCheck.alert += `${this.qtyCheck.items[currIndex].num},`
          }
        }
      }

      if (this.qtyCheck.invalid) {
        this.showTopAlert(`Item(s) ${this.qtyCheck.alert} have total quantities above their limit. Double check quantities with duplicates from kits`, 'danger');
        return false;
      }

      return true;
    },
    processItems() {
      let finalParts = [];
      for (let ix in this.productParts) {
        finalParts.push({
          ProductNumber: this.productParts[ix].num,
          Taxable: false,
          Quantity: this.productParts[ix].qty,
          ProductPrice: 0,
          TotalPrice: 0,
          ItemType: this.productParts[ix].itemType,
          NewItemFlag: false,
          KitItemFlag: this.productParts[ix].level > 0,
        })
      }
      return finalParts;
    },
    getCustomFields() {
      let xmlString = '';
      if (this.notes.returnFlag) {
        xmlString += `<CustomField>
            <Id>114</Id>
            <Type>CHECKBOX</Type>
            <Name>TP Items will be returned</Name>
            <Description>Items on a Took Part order are going to be returned to Ops</Description>
            <SortOrder>14</SortOrder>
            <Info>1</Info>
          </CustomField>`;
      }

      if (this.notes.project.length > 0) {
        xmlString += `<CustomField>
            <ID>115</ID>
            <Type>LONG_TEXT</Type>
            <Name>TP Project Description</Name>
            <Description>Description of why these items are on a Took Part order</Description>
            <SortOrder>15</SortOrder>
            <Info>${this.esc(this.notes.project)}</Info>
          </CustomField>`;
      }

      return xmlString;
    },
    async newSubmit() {

      if (this.productParts.length == 0) {
          RequestService.emailSoloRequest( this.googleUser, this.nonProductParts, this.notes );
          return;
      }

      let receivedNum = 0;
      for (let i = 0; i <= 20; i++) {
        receivedNum = await RequestService.getOrderNumber();
        if (receivedNum != 'wait') break;
        this.$refs['spinner-modal'].show();
        await Utility.timeout(1000);
        if (i == 15) {
          this.$refs['spinner-modal'].hide();
          this.showModal('Try resubmitting in a minute.', 'info spent too long in an order issuing mode. Contact IT if the error persists');
          return;
        }
      }

      this.$refs['spinner-modal'].hide();
      if (receivedNum == 'error') {
        this.showModal('An error occured getting a valid order num.');
        return;
      }

      this.orderNum = receivedNum;
      let soAddUUID = await RequestService.addSO(jsontoxml(this.getOrderData()), this.orderNum);

      this.showModal('Submitted, Waiting for status response...');

      let soStatus = 10;
      for (let i = 0; i <= 20; i++) {
        soStatus = await RequestService.getChampStatus(soAddUUID, i);
        if (soStatus != 10) break;
        await Utility.timeout(1000);
      }


      switch (soStatus) {
        case -1:
          this.showModal('An error occured getting the status of the order.', RequestService.getError(), 'Close', 'light');
          return;
        case -2:
          this.showModal('Status of order request unknown. Click view order to see if your order has been issued. Creating the pick was not attempted',
                          `Request Timed Out for CHAMP command soAdd uuid: ${soAddUUID}`, 'View order', 'light', `/sales-order/view/${this.orderNum}`);
          return;
        case -3:
          return;
        default:
          this.showModal(`SalesOrder #${this.orderNum} received, attempting to commit pick...`);
          break;
      }

      let pickAddUUID = await RequestService.commitPick(this.orderNum);
      let pickStatus = 10;
      for (let i = 0; i <= 20; i++) {
        pickStatus = await RequestService.getChampStatus(pickAddUUID, i);
        if (pickStatus != 10) break;
        await Utility.timeout(1000);
      }

      switch (pickStatus) {
        case -1:
          this.showModal(`Your order: #${this.orderNum}, was issued, but an error occured getting the status of the pick.`,
                          RequestService.getError(), 'View order', 'light', `/sales-order/view/${this.orderNum}`);
          this.emailUsers(false);
          return;
        case -2:
          this.showModal(`Your order: #${this.orderNum}, was issued, but the status of pick request is unknown. No further action is required`,
                          `Request Timed Out for CHAMP command pickStart uuid: ${pickAddUUID}`, 'View order', 'light', `/sales-order/view/${this.orderNum}`);
          this.emailUsers(false);
          return;
        case -3:
          this.showModal(`Your order: #${this.orderNum}, was issued, but the status of pick request is unknown.`,
                          RequestService.getError(), 'View order', 'light', `/sales-order/view/${this.orderNum}`);
          this.emailUsers(false);
          return;
        default:
          this.showModal(`Success!! SalesOrder #${this.orderNum} was issued and a pick was committed!`,
                          '', 'View order', 'light', `/sales-order/view/${this.orderNum}`);
          this.emailUsers();
          break;
      }
    },
    emailUsers( pickCommitted = true ) {
      RequestService.emailUsers(this.googleUser, this.notes, this.orderNum, this.nonProductParts, pickCommitted);
    },
    getOrderData() {
      var notesToSubmit = this.notes.text
      if (this.notes.returnFlag) notesToSubmit += ' --ReturnFlag: ' + this.notes.returnFlag;
      if (this.notes.project != '') notesToSubmit += ' --Project: ' + this.notes.project;
      notesToSubmit += ' --Email: ' + this.googleUser.emails.value;
      notesToSubmit += ' --Request placed by ' + this.googleUser.names.displayNameLastFirst;
      notesToSubmit = this.esc(notesToSubmit);

      return {
        SOSaveRq: {
          SalesOrder: {
            Note: notesToSubmit,
            Salesman: 'admin',
            Number: this.orderNum,
            Status: 20,
            Carrier: 'Pick Up at AndyMark HQ',
            TaxRateName: 'Out Of State',
            ShippingTerms: this.esc('Prepaid & Billed'),
            PaymentTerms: 'NONE',
            CustomerContact: this.googleUser.displayNameLastFirst,
            CustomerName: this.notes.user_department,
            FOB: 'Origin',
            QuickBooksClassName: 'None',
            LocationGroup: 'AMHQ',
            PriorityID: 30,
            BillTo: {
              Name: this.notes.user_department,
              AddressField: '1900 E North Street',
              City: 'Kokomo',
              Zip: '46901',
              Country: 'US',
              State: 'IN'
            },
            Ship: {
              Name: this.notes.user_department,
              AddressField: '1900 E North Street',
              City: 'Kokomo',
              Zip: '46901',
              Country: 'US',
              State: 'IN'
            },
            Items: {
                SalesOrderItem: this.processItems(),
            },
            CustomFields: this.getCustomFields(),
          },
          IssueFlag: false,
        }
      }
    },
    showNotesModal() {
      if (!this.userLoggedIn) {
        this.showTopAlert('Please log in before creating your request', 'danger');
      } else if (this.parts.length == 0) {
        this.showTopAlert('Please add your items to your request', 'danger');
      } else if (!this.partAmountsValid()) {
        this.showTopAlert('Please choose valid amounts for all of your order items', 'danger');
      } else {
        this.notes.show = true;
      }
    },
    showModal( text, errorText='', buttonText = '', variant = 'light', redirect = '', spinner = false ) {
      this.modal.text = text;
      this.modal.error_text = errorText;
      this.modal.button_text = buttonText;
      this.modal.variant = variant;
      this.modal.redirect = redirect;
      this.modal.spinner = spinner;
      this.modal.show = true;
    },
    showTopAlert( text, variant ) {
      this.top_alert.text = text;
      this.top_alert.variant = variant;
      this.top_alert.show = true;
    },
    updateFileModal(value) {
      this.listUpload.visible = value;
    },
    partAmountsValid() {
      for (var ix in this.parts) {
        if (this.parts[ix].qty > (this.parts[ix].available + this.parts[ix].canBuild) || this.parts[ix].qty <= 0) {
          return false;
        }
      }
      return true;
    },
    getProductRequestString() {
      var items = '';
      this.nonProductParts.map((x) => {
        items += `${x.qty}x ${x.num}\n` ;
        return x;
      })
      return items;
    },
  },
  watch: {
    googleUser: function(){
      if (this.googleUser != null) {
        this.top_alert.show = false;
      }
    },

  }
}

</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/sales-order/inventory-request/InventoryRequestOrder.vue